import { useTranslation } from "react-i18next";

interface TagFilterProps {
  tags: string[];
  selected: string | null;
  onSelect: (tag: string | null) => void;
}

export function TagFilter({ tags, selected, onSelect }: TagFilterProps) {
  const { t } = useTranslation();

  const pillStyle = (active: boolean) =>
    ({
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: 11,
      textTransform: "uppercase" as const,
      letterSpacing: "0.14em",
      padding: "6px 14px",
      borderRadius: 999,
      border: `1px solid ${active ? "var(--lavender-400)" : "var(--dyna-border)"}`,
      background: active ? "rgba(156,139,194,0.18)" : "var(--dyna-bg-elevated)",
      color: active ? "var(--lavender-300)" : "var(--dyna-fg-muted)",
      cursor: "pointer",
      transition: "all 200ms ease",
    });

  return (
    <div
      role="toolbar"
      aria-label="Filter articles by tag"
      style={{ display: "flex", gap: 8, flexWrap: "wrap" }}
    >
      <button
        type="button"
        onClick={() => onSelect(null)}
        style={pillStyle(selected === null)}
      >
        {t("pages.blog.allTags")}
      </button>
      {tags.map((tag) => (
        <button
          key={tag}
          type="button"
          onClick={() => onSelect(tag)}
          style={pillStyle(selected === tag)}
        >
          {tag}
        </button>
      ))}
    </div>
  );
}
